export default "/images/vendor/flag-icon-css/flags/4x3/dm.svg?466757644ba07a8bbf786eae1222a578";